
import {
  defineComponent,
  ref,
  onMounted,
  reactive,
  inject,
} from 'vue';
import {
  Modal,
  Input,
  Select,
  // Switch,
  ConfigProvider,
  DatePicker,
  message,
} from 'ant-design-vue';
import { EyeOutlined, EyeInvisibleOutlined, } from '@ant-design/icons-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import moment, { Moment, } from 'moment';
import { postRequest, } from '@/request/request';
import { md5Password, } from '@/utils/index';

export default defineComponent({
  components: {
    Input,
    Select,
    Option,
    // Switch,
    ConfigProvider,
    DatePicker,
    EyeInvisibleOutlined,
    EyeOutlined,
  },
  props: {
    baseInfo: {
      type: Object,
      default: () => ({}),
    },
    formDisabled: {
      type: Boolean,
      default: () => false,
      require: false,
    },
  },
  setup (props, { emit, }) {
    const itemInfo: any = inject('itemInfo');
    const isDisabled = ref(false);
    const tempObj = {
      province: '',
      city: '',
      county: '',
      userLevel: '',
      accountName: '',
      companyName: '',
      expirationTime: moment().add(3, 'months'),
      isOpen: 1,
      tel: '',
      password: '',
      headerTitle: '',
      fireId: '',
      street: '',
    };
    const formData: any = ref(tempObj);
    // 是否显示密码
    const isShowPwd = ref(false);
    const provinceDataArr:any = ref([]);
    const cityDataArr:any = ref([]);
    const countyDataArr:any = ref([]);
    const selectTab = ref<any>('basic');
    const accountLevelList = {
      1: '省级',
      2: '市级',
      3: '县级',
    };

    const range = (start: number, end: number) => {
      const result = [];

      for (let i = start; i < end; i++) {
        result.push(i);
      }

      return result;
    };
    const disabledDate = (current: Moment) => current && current < moment().endOf('day');

    const filterOption = (input: any, option: any) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;

    const initForm = (data: any) => {
      const {
        id, province, city, county, userLevel, accountName, companyName, tel, password, expirationTime, isOpen,headerTitle,fireId,street,
      } = data || {};

      if (id) {
        isDisabled.value = true;
      }

      formData.value.province = province ?? '';
      formData.value.city = city ?? '';
      formData.value.county = county ?? '';
      formData.value.userLevel = accountLevelList[userLevel] ?? '';
      formData.value.accountName = accountName ?? '';
      formData.value.companyName = companyName ?? '';
      formData.value.tel = tel ?? '';
      formData.value.password = password ?? '';
      formData.value.expirationTime = expirationTime ?? formData.value.expirationTime;
      formData.value.isOpen = isOpen ?? '';
      formData.value.headerTitle = headerTitle ?? '';
      formData.value.fireId = fireId ?? '';
      formData.value.street = street ?? '';
    };

    /**
     * 获取下拉省级数据
     * @param {number} type 1、省级  2、市级 3、县
     * @param {string} id id
     * @returns {void}
     */
    const getRegionInfoFunc = (type: number, id?: string) => {
      const params = {
        regionLevel: type,
        id: type === 1 ?
          null :
          id,
      };

      postRequest('/openUser/queryRegion', params)
        .then(({ data, }: any) => {
          if (type === 1) {
            provinceDataArr.value = data.map((item: any) => ({
              value: item.province,
              id: item.id,
              label: item.province,
            }));
          } else if (type === 2) {
            cityDataArr.value = data.map((item: any) => ({
              value: item.city,
              id: item.id,
              label: item.city,
            }));
            cityDataArr.value.unshift({
              value: '',
              label: '不选择',
            });
            countyDataArr.value = [];
            formData.value.city = '';
            formData.value.county = '';
          } else if (type === 3) {
            countyDataArr.value = data.map((item: any) => ({
              value: item.county,
              id: item.id,
              label: item.county,
            }));
            countyDataArr.value.unshift({
              value: '',
              label: '不选择',
            });
            formData.value.county = '';
          }
        });
    };

    /**
     * 获取下拉省级数据，然后调用市级查询
     * @returns {void}
     */
    const handleChangeProvince = (value: any,opt:any) => {
      const { id, } = opt;

      formData.value.headerTitle = `${formData.value.province}大气污染智慧管控平台`;
      formData.value.userLevel = 'province';

      getRegionInfoFunc(2, id);
    };

    /**
     * 获取下拉市级数据，然后调用县级查询
     * @returns {void}
     */
    const handleChangeCity = (value: any,opt:any) => {
      const { id, } = opt;

      if (value === '') {
        formData.value.headerTitle = `${formData.value.province}大气污染智慧管控平台`;
        formData.value.userLevel = 'province';
      } else {
        formData.value.headerTitle = `${formData.value.city}大气污染智慧管控平台`;
        formData.value.userLevel = 'city';
      }

      getRegionInfoFunc(3, id);
    };

    // 县级区域改变
    const handleChangeCounty = (value: any,opt:any) => {
      if (value === '') {
        formData.value.headerTitle = `${formData.value.city}大气污染智慧管控平台`;
        formData.value.userLevel = 'city';
      } else {
        formData.value.headerTitle = `${formData.value.county}大气污染智慧管控平台`;
        formData.value.userLevel = 'county';
      }
    };

    // 验证表单合法性
    const checkForm = (list:any) => {
      /* eslint-disable */
      const phoneReg = /^1[3,4,5,6,7,8,9][0-9]{9}$|[a-z]/;
      const passwordReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]*$/;

      const regionId = list.county ?
        list.county :
        list.city ?
          list.city :
          list.province;

      if (!regionId) {
        message.warning('账号区域不能为空！');
        return false;
      }
      if (!list.userLevel) {
        message.warning('级别不能为空！');
        return false;
      }
      if (!list.accountName) {
        message.warning('用户名不能为空！');
        return false;
      }
      if (!list.companyName) {
        message.warning('使用组织不能为空！');
        return false;
      }

      if (!list.expirationTime) {
        message.warning('到期时间不能为空！');
        return false;
      }
      if (!list.tel) {
        message.warning('手机号/账号不能为空！');
        return false;
      }
      if (!phoneReg.test(list.tel)) {
        message.warning('手机号/账号格式不正确！');
        return false;
      }
      if (!list.password) {
        message.warning('密码不能为空！');
        return false;
      }
      if (list.password.length !== 10) {
        message.warning('密码长度为10个字符！');
        return false;
      }
      if (!passwordReg.test(list.password)) {
        message.warning('密码必须是数字和字母组合！');
        return false;
      }
      if (!props.formDisabled && !list.headerTitle) {
        message.warning('系统标题不能为空！');
        return false;
      }

      return true;
    };

    const handleCancle = () => {
      emit('cancel');
    };
    const handleSave = () => {
      const formValidate = checkForm(formData.value);
      const params = JSON.parse(JSON.stringify(formData.value));
      params.password = md5Password(formData.value.password, formData.value.tel)
      params.street = params.street.replace(/\s*/g,"");
      const { id, regionId} = itemInfo.value;

      if(id){
        params.id = id;
        params.regionId = regionId;
      }

      if (formValidate) {
        params.isOpen = 1;
        params.expirationTime = moment(formData.value.expirationTime).format('YYYY-MM-DD HH:mm:[00]');
        return params;
      } else {
        return false;
      }
    };

    const clickTabButton = (val: string) => {
      selectTab.value = val;
      // emit('typeChange', val);
    };

    const switchClick = () => {
      if(formData.value.isContainHot === 1) {
        formData.value.isContainHot = 0;
      } else {
        formData.value.isContainHot = 1;
      }
    };

    //密码显示状态切换
    const changePwdSHow = () => {
      isShowPwd.value = !isShowPwd.value;
    };

    //生成密码
    const generatePwd = ()=>{
      formData.value.password = 'htht123456'
    }

    onMounted(() => {
      getRegionInfoFunc(1);
      initForm(itemInfo.value);
    });

    return {
      zhCN,
      formData,
      provinceDataArr,
      cityDataArr,
      countyDataArr,
      selectTab,
      isDisabled,
      isShowPwd,

      handleCancle,
      handleSave,
      disabledDate,
      filterOption,
      handleChangeProvince,
      handleChangeCity,
      handleChangeCounty,
      clickTabButton,
      switchClick,
      changePwdSHow,
      generatePwd,
    };
  },
});
